import React, {useState, useEffect, useRef} from 'react';
import {Link} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import PersonalDetailsIcon from '../assets/img/personal-details-icon.png';
import '../assets/css/candidate-tab-form.css';
import BagIcon from '../assets/img/bag-icon.svg';
import CallIcon from '../assets/img/call-icon.png';
import EmailIcon from '../assets/img/email-icon.png';

import { useDispatch, useSelector } from "react-redux";
import { getProfessionalReference, addProfRef } from '../Actions/professionalReferenceActions';
import MainForm from './ProfessionalReferenceForm/MainForm';
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import { getData } from "../Actions/landingAction";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";

import {
  useParams,
} from "react-router-dom";
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidateProfessionalReference = ()=> {

  let { activeTab, reference } = useParams();
  const dispatch = useDispatch();
  const [profReference, setProfReference] = useState([]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [clientId,setClientId]=useState();
  const [role,setRole]=useState();

  useEffect(() => {
    window.scrollTo(0,0)
  }, []);

  //loading form fields information with get professional-reference api
  useEffect(() => {
    const fetchData = async () => {
      dispatch(getProfessionalReference());
      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
      setClientId(userLocalData?.bridge_client_id  || userLocalData?.client_id);

    };
    fetchData();
  }, []);

  const storeData = useSelector((state) => state.profReference);
  const { profReferenceData } = storeData;

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (
      typeof profReferenceData.data !== "undefined" &&
      profReferenceData.data !== null
    ) {
      setProfReference(profReferenceData.data.data);
      setCheckStatus(0);
    }
  }, [profReferenceData, storeData]);

  const reRenderAgain = (value) => {
    dispatch(getProfessionalReference()); 
  }

  const [checkStatus, setCheckStatus] = useState(0);
  useEffect(() => {
    if ( typeof profReference.checksDetails !== "undefined" && profReference.checksDetails !== null) {
      Object.entries(profReference.checksDetails).map(([key, value]) => {
        if (value.check_status != 2) {
          setCheckStatus(1);
        }
      });
    }
  }, [profReference]);

  // const handleProfRefAddClick = (e) => {
  //   e.preventDefault();
  //   if (checkStatus == 1) {
  //     alert("Save the existing professional reference, before adding a new one");
  //   } else {
  //     let text = "Are you sure?";
  //     if (window.confirm(text) == true) {
  //       dispatch(addProfRef());
  //     } else {
        
  //     }
  //   }
  // };

  const handleProfRefAddClick = (e) => {
    e.preventDefault();
    handleAddPopup();
  };

  const handleAddPopup = () => {
    setShowAddPopup(true);
  };

  const closeAddPopup = () => {
    setShowAddPopup(false);
  };

  const proceedAdd = () => {
    dispatch(addProfRef());
    setShowAddPopup(false);
  };
  
  const addProfRefStoreData = useSelector((state) => state.profRefAdd);
  const { profRefData} = addProfRefStoreData;

  useEffect(() => {
    if ( typeof profRefData.data !== "undefined" && profRefData.data !== null) {
      dispatch(getData()); 
      reRenderAgain();
    }
  }, [profRefData]);

    return (
      <>

      <NotificationPanels/>
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header/>
      <Sidebar/> */}

      <section className="main-section candidate-tab-form" style={{paddingTop: '60px'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Professional Reference"}/>
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}
              <form className="p-3 form2 form-section" style={{minHeight: '700px'}}>
              <StepCount activeTab={"Professional Reference"}/>
              <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                <div>
                  <h2 className="fnt-smi-bld">Professional Reference</h2>
                  <p className="text-muted">{  clientId == "394129" ? "You will have to provide professional references from the same employer":"You may provide professional references of any of the previous organizations."}</p>
                  {  clientId == "465931" && <p className="text-muted">{'Need to add your last reporting manager/senior details'}</p>}
                </div>
                {profReference.is_custom_prof_ref == 1 && 
                  <button className="btn btn-primary add-btn" style={{ minWidth: '155' + 'px' }} onClick={(e) => handleProfRefAddClick(e)}>+ Add Professional Reference</button>
                }
              </div>
              <hr/>

                <MainForm 
                  profReference={profReference} 
                  reRenderAgain={reRenderAgain} 
                  active={activeTab}
                  reference={reference}
                  showAddPopup={showAddPopup}
                  closeAddPopup={closeAddPopup}
                  proceedAdd={proceedAdd}
                  checkStatus={checkStatus}
                />
              {/*Form*/}
            </form>
              <Footer />
            </div>
          </div>
        </div>
      </section>

      </>
    );
}
export default CandidateProfessionalReference;